import React from 'react';
import { Bubble } from 'tea-component';
import ChannelLabel, { ChannelIconType } from '@op/components/ChannelLabel';
import { CHANNEL_NAME_SPECIAL_MAP } from '../AdInfoCell/constants';
import './index.scss';
import BubbleCommon from '@op/components/BubbleCommon';

/** Normalize channel/platform name to ChannelLabel icon key */
export const normalizeChannelName = (name: string): ChannelIconType => {
  const lower = name.toLowerCase().trim();
  return CHANNEL_NAME_SPECIAL_MAP[lower] || (lower as ChannelIconType);
};

export interface IChannelItemProps {
  /** List of channel/platform names */
  list: string[];
  /** Max visible icons before collapsing */
  maxVisible?: number;
  /** Icon size */
  iconSize?: number;
  /** Show text label (default: false) */
  showText?: boolean;
  className?: string;
}

/**
 * ChannelItem — shows first N channel icons, hover bubble for the rest
 * Pattern follows CountryItem's bubble tooltip approach.
 */
export default function ChannelItem({
  list,
  maxVisible = 3,
  iconSize = 16,
  showText = false,
  className,
}: IChannelItemProps) {
  if (!list || list.length === 0) return null;

  const visible = list.slice(0, maxVisible);
  const rest = list.slice(maxVisible);

  return (
    <div className={`dbom-channel-item ${className}`}>
      {visible.map((name: string, idx: number) => (
        <BubbleCommon
          showIcon={false}
          tipsMap={null}
          key={idx}
          placement='top'
          content={
            showText ? undefined : (
              <ChannelLabel
                showText={true}
                iconStyle={{ width: iconSize, height: iconSize }}
                channel_name={normalizeChannelName(name)}
                isMarketing
              />
            )
          }
        >
          <ChannelLabel
            className="dbom-line-divider"
            showText={showText}
            iconStyle={{ width: iconSize, height: iconSize }}
            channel_name={normalizeChannelName(name)}
            isMarketing
          />
        </BubbleCommon>
      ))}
      {rest.length > 0 && (
        <Bubble
          content={
            <div className="dbom-channel-item__tooltip">
              {rest.map((name: string, idx: number) => (
                <ChannelLabel
                  key={idx}
                  showText
                  iconStyle={{ width: iconSize, height: iconSize }}
                  channel_name={normalizeChannelName(name)}
                />
              ))}
            </div>
          }
        >
          <span className="dbom-channel-item__more">+{rest.length}</span>
        </Bubble>
      )}
    </div>
  );
}
